<template>
  <CardOrder
    :orders="filteredOrders"
    @edit-order="editItem"
    :tables="allTables"
  />
</template>

<script>
import CardOrder from "@/components/card-dashboard/card-order/CardOrder.vue";
import { mapGetters } from "vuex";

export default {
  name: "ListOrder",
  props: {
    orders: {
      type: Object,
      default: null,
    },
    orderType: {
      type: String,
      default: '',
    },
    searchOrder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedOrder: null,
    };
  },
  components: {
    CardOrder,
  },
  computed: {
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("sales_orders", ["allSalesOrders"]),
    ...mapGetters("cash_registers", ["allCashRegisters"]),
    relevantCashRegister() {
      const cashRegisters = [...this.allCashRegisters];
      return cashRegisters?.find((cr) => cr.status === "open");
    },
    filteredOrders() {
      let salesOrders = [...this.allSalesOrders];
      const tables = [...this.allTables];
      if (!salesOrders) return [];
      salesOrders = salesOrders.map((so) => ({
        ...so,
        table: tables?.find((table) => table.id === so.table_id),
      }));
      let notAllowedStatus = ["canceled", "paid"];
      let filtered = salesOrders.filter(
        (so) => !notAllowedStatus.includes(so.status)
      );
      if (this.orderType)
        filtered = filtered.filter(
          (so) => so.order_type === this.orderType
        );

      if (this.searchOrder)
        filtered = filtered.filter(
          (transaksi) =>
            transaksi?.table?.name?.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1 ||
            transaksi?.customer_name?.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1 ||
            transaksi?.code?.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1
        );
      return filtered;
    },
  },
  async created() {
    await this.$store.dispatch("tables/fetchTables");
    await this.$store.dispatch("cash_registers/fetchCashRegisters");
    if (this.relevantCashRegister) {
      await this.$store.dispatch("sales_orders/fetchSalesOrders", {
        cash_register_id: this.relevantCashRegister.id,
      });
    } else {
      this.$store.commit('sales_orders/resetSalesOrders');
    }
  },
  methods: {
    async editItem(item) {
      this.selectedOrder = item;
      this.$router.push({
        name: 'order',
        query: { orderId: item.id }
      });
    },
    getRelevantTable(order) {
      const tables = [...this.allTables];
      return tables?.find((table) => table.id === order.table_id);
    },
  },
};
</script>
